export default "__VITE_ASSET__DGG_kUSk__"